<template>
  <q-page padding>
    <q-dialog v-model="showModal" persistent ref="dialogPassword">
      <q-card style="width: 800px; max-width: 80vw">
        <q-form>
          <q-toolbar class="bg-primary text-white">
            <q-toolbar-title> {{ $t('existing_campaigns') }}</q-toolbar-title>
          </q-toolbar>
          <q-card-section class="row q-col-gutter-md">
            <div class="col-12">
              <p class="text-red-5">
                <b>{{ $t('attention') }}!</b> {{ $t('existing_campaigns_message') }}
              </p>
              <p class="text-red-5">
                {{ $t('existing_campaigns_message_2') }}
              </p>
            </div>
          </q-card-section>
          <q-card-section>
            <q-table
              :data="dataCampaignsByAdvertiser"
              flat
              bordered
              hide-no-data
              hide-bottom
              :pagination="{
                sortBy: 'name',
                rowsPerPage: 100
              }"
              :columns="[
                {
                  name: 'name',
                  align: 'left',
                  label: $t('name'),
                  field: 'name'
                },
                {
                  name: 'status',
                  align: 'left',
                  label: 'Status',
                  field: 'status'
                }
              ]"
            >
              <template v-slot:body-cell-status="props">
                <q-td :props="props">
                  <q-chip v-if="props.value === 0" text-color="white" color="warning">{{ $t('pending') }}</q-chip>
                  <q-chip v-if="props.value === 1" text-color="white" color="primary">{{ $t('activated') }}</q-chip>
                  <q-chip v-if="props.value === 2" text-color="white" color="accent">{{ $t('paused') }}</q-chip>
                  <q-chip v-if="props.value === 3" text-color="white" color="negative">{{ $t('disabled') }}</q-chip>
                  <q-chip v-if="props.value === 4" text-color="white" color="purple">{{
                    $t('in_implementation')
                  }}</q-chip>
                </q-td>
              </template>
            </q-table>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn no-caps class="q-px-md" unelevated :label="$t('aware')" color="primary" v-close-popup />
          </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>

    <q-form @validation-success="advanceVerify" @submit="onSave">
      <q-toolbar class="column">
        <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">
          <!-- {{ campaignSelect ? $t('edit') : $t('registration_of') }}{{ $t("campaigns") }} -->
          {{ $t('campaigns_registration') }}
        </q-toolbar-title>
        <q-breadcrumbs class="q-mr-auto q-ma-sm">
          <q-breadcrumbs-el :label="$t('dashboard')" to="/ " />
          <q-breadcrumbs-el :label="$t('campaigns')" to="/campaigns" />
          <q-breadcrumbs-el :label="$t('campaigns_registration')" exact />
        </q-breadcrumbs>
      </q-toolbar>
      <q-separator spaced />
      <q-card flat class="q-mt-md">
        <q-card-section class="row items-center">
          <q-stepper
            v-model="step"
            ref="formCampaign"
            color="primary"
            animated
            :header-nav="!!campaignSelect"
            alternative-labels
            flat
            class="full-width"
          >
            <!-- FORM BEGINS -->

            <!-- STEP 1 -->
            <q-step name="step1" :title="$t('step') + ' 1'" icon="mdi-domain" :done="step > 1">
              <q-card flat>
                <q-separator />
                <q-card-section class="row q-col-gutter-md q-pa-none">
                  <div class="col-12 q-mt-md">
                    <q-checkbox v-model="form.is_test" val="anunciante" :label="$t('test_campaign')" />
                  </div>
                  <div class="col-4">
                    <select-request
                      :v-model="form.advertiser"
                      outlined
                      label="Advertiser*"
                      endpoint="/redirect?app=ADVERTISER&path=/api/get/advertiser/bytype/anunciante"
                      option-label="trademark"
                      option-value="id"
                      clearable
                      @update="
                        (value) => {
                          checkExistCampaign(value.id);
                          form.advertiser = value;
                        }
                      "
                      :rules="[isRequired]"
                    />
                  </div>

                  <div class="col-4">
                    <select-request
                      :v-model="form.agency_id"
                      outlined
                      :label="$t('agency')"
                      endpoint="/redirect?app=ADVERTISER&path=/api/get/advertiser/bytype/agencia"
                      option-label="trademark"
                      option-value="id"
                      clearable
                      @update="
                        (value) => {
                          form.agency_id = value;
                        }
                      "
                    />
                  </div>

                  <div class="col-4">
                    <select-request
                      :v-model="form.comercial_manager"
                      :label="$t('comercial_manager') + '*'"
                      outlined
                      endpoint="user/user-unblocked-by-profile/1,2"
                      option-label="name"
                      option-value="id"
                      clearable
                      @update="
                        (value) => {
                          form.comercial_manager = value;
                        }
                      "
                      :rules="[isRequired]"
                    />
                  </div>

                  <div class="col-6">
                    <!-- <span class="text-weight-medium">Nome da Campanha*</span> -->
                    <q-input
                      outlined
                      v-model="form.name"
                      type="text"
                      :label="$t('name') + ' ' + $t('of_3') + ' ' + $t('campaign') + '*'"
                      lazy-rules
                      :rules="[isRequired]"
                    />
                  </div>

                  <div class="col-6">
                    <!-- <span class="text-weight-medium">Nome da Campanha*</span> -->
                    <q-input
                      outlined
                      v-model="form.campaign_description"
                      autogrow
                      :label="$t('description') + ' ' + $t('of_3') + ' ' + $t('campaign') + '*'"
                      lazy-rules
                      :rules="[isRequired]"
                    />
                  </div>

                  <div class="col-4">
                    <div class="row q-col-gutter-sm">
                      <div class="col-4">
                        <q-select
                          v-model="form.url.protocol"
                          :options="['https://', 'http://']"
                          label="Protocol URL*"
                          outlined
                          clearable
                          clear-icon="mdi-close"
                          :rules="[isRequired]"
                        />
                      </div>
                      <div class="col-8">
                        <q-input
                          outlined
                          type="text"
                          label="URL*"
                          v-model="form.url.link"
                          lazy-rules
                          :rules="[isRequired]"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-8">
                    <div class="row q-col-gutter-sm">
                      <div class="col-5">
                        <select-request
                          :v-model="form.segmentation"
                          :label="$t('segmentation')"
                          outlined
                          endpoint="redirect?app=ADVERTISER&path=/api/get/campaign/segmentation"
                          option-label="description"
                          option-value="id"
                          clearable
                          @update="
                            (value) => {
                              form.segmentation = value === null ? null : value.id;
                            }
                          "
                          :rules="[isRequired]"
                        />
                      </div>

                      <div class="col-4">
                        <q-select
                          use-input
                          v-model="form.category_id"
                          @filter="filterCategories"
                          :options="categoriesFiltered"
                          option-label="name"
                          outlined
                          clear-icon="mdi-close"
                          clearable
                          option-value="id"
                          :label="$t('category') + '*'"
                          lazy-rules
                          :rules="[(val) => !!val || 'Field is required']"
                        />
                      </div>
                      <q-checkbox class="col-3 q-pb-md" v-model="form.is_exclusive" :label="$t('exclusive_campaign')" />
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="row q-col-gutter-sm">
                      <div class="col-6">
                        <date-input
                          :v-model="form.activation_date"
                          outlined
                          :label="$t('start_date') + '*'"
                          :rules="[isRequired]"
                          @update="form.activation_date = $event"
                        />
                      </div>

                      <div class="col-6">
                        <date-input
                          :v-model="form.expiration_date"
                          outlined
                          :label="$t('end_date')"
                          @update="form.expiration_date = $event"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="row q-col-gutter-sm">
                      <div class="col-4">
                        <q-select
                          v-model="form.budget_currency"
                          :options="currencyOptions"
                          label="Budget"
                          outlined
                          clearable
                          clear-icon="mdi-close"
                          emit-value
                          map-options
                        />
                      </div>
                      <div class="col-8">
                        <q-input outlined type="number" :label="$t('unlimited_value')" v-model="form.budget_amount" />
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <!-- <q-uploader
                      label="Logo"
                      color="primary"
                      flat
                      bordered
                      accept=".jpg,.jpeg,.png,.gif"
                      class="full-width"
                      max-files="1"
                      :factory="factoryFn"
                      ref="logoCampaign"
                    /> -->
                    <q-file
                      outlined
                      ref="images"
                      v-model="logo"
                      accept=".jpg,.jpeg,.png,.gif"
                      class="file-upload q-pt-md"
                      style="z-index: 1 !important"
                    >
                      <template v-slot:prepend v-if="logo == null">
                        <div class="full-width bg-transparent absolute-center text-center">
                          <div class="absolute text-body1" style="top: -30px; left: 10px">Logo</div>
                          <div class="text-h6 text-primary">{{ $t('drag_and_drop') }}!</div>
                          <div class="text-caption">...{{ $t('or') }} {{ $t('click_to_upload') }}</div>
                        </div>
                      </template>
                      <template v-slot:file="{ file }">
                        <div class="q-pa-md text-center">
                          <div class="absolute text-body1 text-grey-6" style="top: 5px; left: -5px">Logo</div>
                          <q-card flat bordered class="q-mt-sm">
                            <q-img :src="parceToUrl(file)" style="width: 200px; height: 200px" contain>
                              <div class="absolute-bottom text-caption text-center">
                                {{ file.name }} -
                                {{ formatBytes(file.size) }}
                              </div>
                            </q-img>
                            <q-btn
                              icon="mdi-close"
                              class="absolute text-white bg-negative"
                              style="top: 15px; right: 0px; transform: translateY(-50%)"
                              dense
                              unelevated
                              @click.prevent="logo = null"
                            />
                          </q-card>
                        </div>
                      </template>
                    </q-file>
                    <!-- <q-btn
                      color="primary"
                      flat
                      label="OK"
                      @click="uploadLogoCampaign(logo)"
                    /> -->
                  </div>

                  <!-- INPUT CPA CPC OU CPL -->
                  <div class="col-12">
                    <q-separator spaced />

                    <div class="row q-col-gutter-sm">
                      <span class="col-12 text-weight-medium">{{ $t('negotiation_model') }}*</span>
                      <div class="col-12">
                        <q-btn @click="addModeloNegociacao('cpa')" label="+ CPA" color="primary" />
                      </div>

                      <!-- CPA -->
                      <div
                        class="col-12 row q-col-gutter-sm"
                        v-for="comission in checkModeloNegociacao('cpa')"
                        :key="comission.id"
                      >
                        <div class="col-3">
                          <q-input
                            outlined
                            v-model="comission.category"
                            type="text"
                            dense
                            :label="$t('name') + '*'"
                            :rules="[isRequired]"
                          />
                        </div>

                        <div class="col-3">
                          <q-select
                            v-model="comission.format"
                            :options="[
                              { label: 'Valor', value: 'value' },
                              {
                                label: 'Porcentagem',
                                value: 'percentage'
                              }
                            ]"
                            :label="$t('value') + '*'"
                            outlined
                            dense
                            emit-value
                            clearable
                            clear-icon="mdi-close"
                            :rules="[isRequired]"
                          />
                        </div>

                        <div class="col-3">
                          <q-select
                            v-model="comission.currency"
                            :options="currencyOptions"
                            emit-value
                            map-options
                            :label="$t('currency') + '*'"
                            outlined
                            dense
                            clearable
                            clear-icon="mdi-close"
                            :rules="[isRequired]"
                          />
                        </div>

                        <div class="col-2">
                          <q-input
                            outlined
                            v-model="comission.value"
                            type="number"
                            dense
                            step="0.01"
                            :label="$t('value') + '*'"
                            :rules="[isRequired]"
                          >
                            <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                              {{ $t('fill_in_the_commission_value_in_reais') }}.
                            </q-tooltip>
                          </q-input>
                        </div>

                        <div class="col-1">
                          <q-btn @click="deleteSpecificObjectInModel(comission.id)" color="negative" icon="mdi-close" />
                        </div>
                      </div>

                      <div class="col-12">
                        <q-btn @click="addModeloNegociacao('cpl')" label="+ CPL" color="primary" />
                      </div>

                      <!-- CPL -->
                      <div
                        class="col-12 row q-col-gutter-sm"
                        v-for="comission in checkModeloNegociacao('cpl')"
                        :key="comission.id"
                      >
                        <div class="col-3">
                          <q-input
                            outlined
                            v-model="comission.category"
                            type="text"
                            dense
                            :label="$t('name') + '*'"
                            :rules="[isRequired]"
                          />
                        </div>

                        <div class="col-3">
                          <q-select
                            v-model="comission.currency"
                            :options="currencyOptions"
                            emit-value
                            map-options
                            :label="$t('currency') + '*'"
                            outlined
                            dense
                            clearable
                            clear-icon="mdi-close"
                            :rules="[isRequired]"
                          />
                        </div>

                        <div class="col-2">
                          <q-input
                            outlined
                            v-model="comission.value"
                            type="number"
                            step="0.01"
                            dense
                            :label="$t('value') + '*'"
                            :rules="[isRequired]"
                          >
                            <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                              {{ $t('fill_in_the_commission_value_in_reais') }}.
                            </q-tooltip>
                          </q-input>
                        </div>

                        <div class="col-1">
                          <q-btn @click="deleteSpecificObjectInModel(comission.id)" color="negative" icon="mdi-close">
                            <!-- <q-tooltip> Remover contato</q-tooltip> -->
                          </q-btn>
                        </div>
                      </div>

                      <div class="col-12">
                        <q-btn
                          @click="addModeloNegociacao('cpc')"
                          label="+ CPC"
                          color="primary"
                          :disabled="!checkExistCPC('cpc')"
                        />
                      </div>

                      <!-- CPC -->
                      <div
                        class="col-12 row q-col-gutter-sm"
                        v-for="comission in checkModeloNegociacao('cpc')"
                        :key="comission.id"
                      >
                        <div class="col-3">
                          <q-input
                            outlined
                            v-model="comission.category"
                            type="text"
                            dense
                            :label="$t('name') + '*'"
                            :rules="[isRequired]"
                          />
                        </div>

                        <div class="col-3">
                          <q-select
                            v-model="comission.currency"
                            :options="currencyOptions"
                            emit-value
                            map-options
                            :label="$t('currency') + '*'"
                            outlined
                            dense
                            clearable
                            clear-icon="mdi-close"
                            :rules="[isRequired]"
                          />
                        </div>

                        <div class="col-2">
                          <q-input
                            outlined
                            v-model="comission.value"
                            type="number"
                            step="0.01"
                            dense
                            :label="$t('value') + '*'"
                            :rules="[isRequired]"
                          >
                            <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                              {{ $t('fill_in_the_commission_value_in_reais') }}.
                            </q-tooltip>
                          </q-input>
                        </div>

                        <div class="col-1">
                          <q-btn @click="deleteSpecificObjectInModel(comission.id)" color="negative" icon="mdi-close">
                            <!-- <q-tooltip> Remover contato</q-tooltip> -->
                          </q-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </q-step>

            <!-- STEP 2 -->
            <q-step name="step2" :title="$t('step') + ' 2'" icon="mdi-card-account-phone-outline">
              <q-card flat>
                <q-separator />
                <q-card-section class="row q-col-gutter-md q-pa-none q-pt-lg">
                  <div class="col-6">
                    <div class="row q-col-gutter-sm">
                      <div class="col-6">
                        <q-input
                          outlined
                          type="number"
                          :label="$t('cookie_time_label') + '*'"
                          v-model="form.cookie_time"
                          lazy-rules
                          :rules="[isRequired]"
                        />
                      </div>
                      <div class="col-6">
                        <q-select
                          v-model="form.cookie_time_metric"
                          :options="[
                            { label: $t('minutes'), value: 'minutos' },
                            { label: $t('hours'), value: 'horas' },
                            { label: $t('days'), value: 'dias' }
                          ]"
                          :label="$t('period') + '*'"
                          outlined
                          emit-value
                          clearable
                          clear-icon="mdi-close"
                          :rules="[isRequired]"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-6 q-gutter-sm">
                    <q-card flat bordered>
                      <q-card-section>
                        <span class="text-weight-medium">{{ $t('restriction') }}*</span>
                        <div class="q-gutter-sm">
                          <q-checkbox
                            v-model="form.restriction_site_under"
                            val="1"
                            label="Site Under"
                            color="primary"
                            @input="(val) => uncheckRestrictionNone(val)"
                          />
                          <q-checkbox
                            v-model="form.restriction_word_purchase"
                            val="2"
                            :label="$t('word_purchase')"
                            color="primary"
                            @input="(val) => uncheckRestrictionNone(val)"
                          />
                          <q-checkbox
                            v-model="form.restriction_retargeting"
                            val="3"
                            label="Retargeting"
                            color="primary"
                            @input="(val) => uncheckRestrictionNone(val)"
                          />
                          <q-checkbox
                            v-model="form.restriction_email_marketing"
                            val="0"
                            label="E-mail Marketing"
                            color="primary"
                            @input="(val) => uncheckRestrictionNone(val)"
                          />
                          <q-checkbox
                            v-model="form.restriction_none"
                            :label="$t('no_restriction')"
                            color="primary"
                            @input="(val) => unchekRestrictions(val)"
                          />
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>

                  <div class="col-6 q-gutter-sm">
                    <q-card flat bordered>
                      <q-card-section>
                        <span class="text-weight-medium">{{ $t('attribution') }}*</span>
                        <div class="q-gutter-sm">
                          <q-checkbox v-model="form.last_click" :label="$t('last_click')" color="primary" />
                          <q-checkbox v-model="form.assisted" :label="$t('assisted')" color="primary" />
                          <q-checkbox v-model="form.direct" :label="$t('direct')" color="primary" />
                          <q-checkbox v-model="form.organic" :label="$t('organic')" color="primary" />
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>

                  <div class="col-6 q-gutter-sm">
                    <q-card flat bordered>
                      <q-card-section>
                        <span class="text-weight-medium">Mobile</span>
                        <div class="q-gutter-sm">
                          <q-checkbox v-model="form.mobile_responsive" :label="$t('responsive')" color="primary" />
                          <q-checkbox v-model="form.mobile_msite" label="MStie" color="primary" />
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>

                  <div class="col-12">
                    <q-separator spaced />

                    <q-toolbar class="bg-white text-dark">
                      <q-toolbar-title class="text-body1"> {{ $t('business_contact_client') }} </q-toolbar-title>

                      <q-btn
                        @click="
                          form.business_contact.push({
                            id: form.business_contact.length + 1,
                            name: null,
                            email: null,
                            phone: null,
                            appendParams: {}
                          })
                        "
                        color="primary"
                        icon="mdi-plus"
                        no-caps
                        unelevated
                      >
                        <q-tooltip> {{ $t('add_new_contact') }} </q-tooltip>
                      </q-btn>
                    </q-toolbar>
                  </div>

                  <div
                    class="col-12 row q-col-gutter-sm"
                    v-for="(contact, index) in form.business_contact"
                    :key="contact.id"
                  >
                    <div class="col-4">
                      <q-input
                        outlined
                        type="text"
                        :label="$t('name') + '*'"
                        dense
                        v-model="contact.name"
                        lazy-rules
                        :rules="[isRequired]"
                      />
                    </div>

                    <div class="col-4">
                      <q-input
                        outlined
                        type="email"
                        label="Email*"
                        dense
                        v-model="contact.email"
                        lazy-rules
                        :rules="[isRequired, isEmail]"
                      />
                    </div>

                    <div class="col-4">
                      <q-input
                        outlined
                        type="text"
                        :label="$t('phone') + '*'"
                        dense
                        v-model="contact.phone"
                        mask="+## ## #####-####"
                        unmasked-value
                        hint="Ex. +55 21 99999-9999"
                        lazy-rules
                        :rules="[isRequired]"
                      >
                        <template v-slot:after>
                          <q-btn
                            v-if="index != 0"
                            @click="form.business_contact.splice(index, 1)"
                            color="negative"
                            icon="mdi-close"
                            unelevated
                            no-caps
                          >
                            <q-tooltip>{{ $t('remove_contact') }}</q-tooltip>
                          </q-btn>
                        </template>
                      </q-input>
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </q-step>

            <!-- STEP 3 -->
            <q-step name="step3" :title="$t('step') + ' 3'" icon="assignment">
              <q-card flat>
                <q-card-section>
                  <q-separator />

                  <div class="col-6 q-gutter-sm">
                    <q-card flat bordered>
                      <q-card-section>
                        <span class="text-weight-medium">{{ $t('integration_type') }}*</span>
                        <div class="q-gutter-sm">
                          <q-radio v-model="form.integration_type" val="Pixel" :label="$t('pixel')" color="primary" />
                          <q-radio
                            v-model="form.integration_type"
                            val="Postback"
                            :label="$t('postback')"
                            color="primary"
                          />
                          <q-radio v-model="form.integration_type" val="API" :label="$t('api')" color="primary" />
                          <q-radio v-model="form.integration_type" val="Mobile" :label="$t('mobile')" color="primary" />
                          <q-radio v-model="form.integration_type" val="Outro" :label="$t('other')" color="primary" />
                          <q-input
                            v-if="form.integration_type === 'Outro'"
                            v-model="otherIntegrationType"
                            :label="$t('add_information')"
                            outlined
                            dense
                          />
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>
                  <br />

                  <div class="col-12 q-gutter-sm">
                    <div class="row q-col-gutter-md">
                      <div class="col-6">
                        <q-card flat bordered>
                          <q-card-section>
                            <span class="text-weight-medium">{{ $t('mastertag') }}*</span>
                            <div class="q-gutter-sm">
                              <p class="text">{{ $t('mastertag_question') }}</p>
                              <q-select
                                :options="[$t('yes'), $t('cancel'), $t('dont_know')]"
                                outlined
                                dense
                                clearable
                                clear-icon="mdi-close"
                                v-model="form.mastertag"
                                :rules="[isRequired]"
                              />
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>
                      <div class="col-6">
                        <q-card flat bordered>
                          <q-card-section>
                            <span class="text-weight-medium">{{ $t('gtm_release') }}*</span>
                            <div class="q-gutter-sm">
                              <p class="text">{{ $t('gtm_release_question') }}</p>
                              <q-select
                                :options="[$t('afilio_team'), $t('client'), $t('dont_know')]"
                                outlined
                                dense
                                clearable
                                clear-icon="mdi-close"
                                v-model="form.gtm_release"
                                :rules="[isRequired]"
                              />
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>
                    </div>
                  </div>
                  <br />

                  <div class="row q-col-gutter-md">
                    <div class="col-12">
                      <q-input
                        outlined
                        v-model="form.parameterized_url"
                        autogrow
                        :label="$t('parameterized_url')"
                        :hint="$t('parameterized_url_hint')"
                        :rules="[isValidUrl]"
                      />
                    </div>
                  </div>
                  <br />

                  <div class="col-6 q-gutter-sm">
                    <q-card flat bordered>
                      <q-card-section>
                        <span class="text-weight-medium">{{ $t('test_method') }}*</span>
                        <div class="q-gutter-sm">
                          <p class="text">{{ $t('test_method_question') }}</p>
                          <div class="row q-col-gutter-md">
                            <div class="col-4">
                              <q-select
                                v-model="form.test_method_real_data_registration"
                                :options="[$t('yes'), $t('cancel'), $t('dont_know')]"
                                :label="$t('real_data_registration') + '*'"
                                outlined
                                dense
                                clearable
                                clear-icon="mdi-close"
                                :rules="[isRequired]"
                              />
                            </div>

                            <div class="col-4">
                              <q-select
                                v-model="form.test_method_no_invoice_purchase"
                                :options="[$t('yes'), $t('cancel'), $t('dont_know')]"
                                :label="$t('purchase_without_invoice') + '*'"
                                outlined
                                dense
                                clearable
                                clear-icon="mdi-close"
                                :rules="[isRequired]"
                              />
                            </div>

                            <div class="col-4">
                              <q-input
                                outlined
                                dense
                                v-model="form.test_method_other_issues"
                                autogrow
                                :label="$t('others')"
                              />
                            </div>
                          </div>
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>
                  <br />

                  <div class="col-6 q-gutter-sm">
                    <q-card flat bordered>
                      <q-card-section>
                        <span class="text-weight-medium">{{ $t('proof_method') }}*</span>
                        <div class="q-gutter-sm">
                          <p class="text">{{ $t('proof_method_question') }}</p>
                          <div class="row q-col-gutter-md">
                            <div class="col-12">
                              <q-input
                                outlined
                                dense
                                v-model="form.proof_method"
                                autogrow
                                :label="$t('add_information')"
                                :rules="[isRequired]"
                              />
                            </div>
                          </div>
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>

                  <q-separator spaced="xl" />

                  <q-toolbar class="bg-white text-dark">
                    <q-toolbar-title class="text-body1">{{ $t('implementation_contact') }}</q-toolbar-title>

                    <q-btn
                      @click="
                        form.pixel_contacts.push({
                          id: form.pixel_contacts.length + 1,
                          name: null,
                          email: null,
                          phone: null,
                          appendParams: {}
                        })
                      "
                      color="primary"
                      icon="mdi-plus"
                      no-caps
                      unelevated
                    >
                      <q-tooltip>{{ $t('add_new_contact') }}</q-tooltip>
                    </q-btn>
                  </q-toolbar>

                  <div
                    class="row q-col-gutter-sm q-pa-none"
                    v-for="(contact, index) in form.pixel_contacts"
                    :key="contact.id"
                  >
                    <div class="col-4">
                      <q-input
                        outlined
                        type="text"
                        :label="$t('name') + '*'"
                        dense
                        v-model="contact.name"
                        lazy-rules
                        :rules="[isRequired]"
                      />
                    </div>

                    <div class="col-4">
                      <q-input
                        outlined
                        type="email"
                        :label="$t('enter_email') + '*'"
                        dense
                        v-model="contact.email"
                        lazy-rules
                        :rules="[isRequired, isEmail]"
                      />
                    </div>

                    <div class="col-3">
                      <q-input
                        outlined
                        type="text"
                        :label="$t('phone') + '*'"
                        dense
                        v-model="contact.phone"
                        mask="+## ## #####-####"
                        unmasked-value
                        :hint="$t('phone_hint')"
                        lazy-rules
                        :rules="[isRequired]"
                      />
                    </div>
                    <div class="col-1">
                      <q-btn
                        v-if="index != 0"
                        @click="form.pixel_contacts.splice(index, 1)"
                        color="negative"
                        icon="mdi-close"
                      />
                    </div>
                  </div>

                  <q-separator spaced="xl" />

                  <div class="row q-col-gutter-md">
                    <div class="col-6">
                      <q-select
                        v-model="form.contract"
                        :options="[$t('yes'), $t('cancel')]"
                        :label="$t('contract_sending') + '*'"
                        outlined
                        clearable
                        clear-icon="mdi-close"
                        :rules="[isRequired]"
                      />
                    </div>

                    <div class="col-6">
                      <q-select
                        v-model="form.pi"
                        :options="[$t('yes'), $t('cancel')]"
                        :label="$t('pi_sending') + '*'"
                        outlined
                        clearable
                        clear-icon="mdi-close"
                        :rules="[isRequired]"
                      />
                    </div>

                    <div class="col-12">
                      <q-input
                        outlined
                        v-model="form.additional_informations"
                        autogrow
                        :label="$t('additional_campaign_information')"
                      />
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </q-step>
          </q-stepper>
        </q-card-section>
        <q-separator inset />
        <q-card-actions align="right" class="q-pa-md">
          <q-btn outline :label="$t('cancel')" no-caps padding="sm lg" color="primary" @click="onClose" v-if="!id" />
          <q-btn
            outline
            v-if="step !== 'step1'"
            :label="$t('back')"
            no-caps
            padding="sm lg"
            color="primary"
            @click="$refs.formCampaign.previous()"
          />
          <q-btn
            unelevated
            color="primary"
            :label="$t('advance')"
            v-if="step !== 'step3'"
            no-caps
            padding="sm lg"
            type="submit"
          />
          <q-btn
            v-if="step === 'step3'"
            unelevated
            :label="$t('save')"
            no-caps
            padding="sm lg"
            color="primary"
            type="submit"
          />
        </q-card-actions>
      </q-card>

      <!-- </q-card> -->
    </q-form>
  </q-page>
  <!-- </q-dialog> -->
</template>

<script>
import CampaignMixin from '../../mixins/CampaignMixin';
import SelectRequest from '@/widgets/inputsGlobal/SelectRequest.vue';
import DateInput from '../../widgets/inputsGlobal/DateInput.vue';
import AdvertiserService from '../../services/AdvertiserService';
import ConversorPhpService from '../../services/ConversorPhpService';

export default {
  components: {
    SelectRequest,
    DateInput
  },

  name: 'FormCampaign',

  mixins: [CampaignMixin, AdvertiserService, ConversorPhpService],

  props: {
    id: {
      type: [String, Number]
    }
  },

  data() {
    return {
      showModal: false,
      dataCampaignsByAdvertiser: [],
      categories: [],
      categoriesFiltered: [],
      tab: 'detalhamento',
      logo: null,
      step: 'step1',
      isento: false,
      otherIntegrationType: null,
      form: {
        is_test: false,
        is_exclusive: false,
        advertiser: null,
        agency_id: null,
        comercial_manager: null,
        name: null,
        campaign_description: null,
        url: {
          protocol: null,
          link: null
        },
        segmentation: null,
        category_id: null,
        activation_date: null,
        expiration_date: null,
        budget_currency: null,
        budget_amount: null,
        cookie_time: null,
        cookie_time_metric: null,

        // atribuicao:
        last_click: false,
        assisted: false,
        direct: false,
        organic: false,

        // mobile:
        mobile_responsive: false,
        mobile_msite: false,

        // restricoes:
        restriction_site_under: false,
        restriction_word_purchase: false,
        restriction_retargeting: false,
        restriction_email_marketing: false,
        restriction_none: false,

        contract: null,
        pi: null,
        business_contact: [{ id: 1, name: null, email: null, phone: null, appendParams: {} }],
        pixel_contacts: [{ id: 1, name: null, email: null, phone: null, appendParams: {} }],
        comissions: [],
        additional_informations: null,

        //Campos informacionais
        integration_type: null,
        mastertag: null,
        gtm_release: null,
        parameterized_url: '',
        test_method_real_data_registration: null,
        test_method_no_invoice_purchase: null,
        test_method_other_issues: null,
        proof_method: null
      },
      indexComissionsArray: 0
    };
  },

  created() {
    this.getCategories();
  },

  methods: {
    isValidUrl(val) {
      /* eslint-disable */
      const regex =
        /((https?|ftp)\:\/\/)?([a-z0-9+!*(),;?&=\$_.-]+(\:[a-z0-9+!*(),;?&=\$_.-]+)?@)?([:\/\a-z0-9-.]*)\.([a-z]{2,5})(\:[0-9]{2,5})?(\/([a-z0-9+\$_-]\.?)+)*\/?(\?[a-z+&\$_.-][a-z0-9!;:@&%=+\/\$_.-\|-]*)?(#[a-z_.-][a-z0-9+\$_.-]*)?/gm;
      /* eslint-enable */

      // if (!regex.test(val)) {
      //   return 'Url é inválida!';
      // }
      // return true;

      return regex.test(val) || val == '' || val == null || this.$t('invalid_url');
    },

    async getCategories() {
      try {
        const { data, status } = await this.listCampaignsCategories();
        if (status === 200) {
          data.sort((a, b) => a.name.localeCompare(b.name));
          this.categories = data;
        }
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      }
    },

    filterCategories(val, update) {
      update(this.defaultFilter(val, 'categoriesFiltered', this.categories, 'name'));
    },

    unchekRestrictions(val) {
      if (val) {
        this.form.restriction_site_under = false;
        this.form.restriction_word_purchase = false;
        this.form.restriction_retargeting = false;
        this.form.restriction_email_marketing = false;
      }
    },

    uncheckRestrictionNone(val) {
      if (val) {
        this.form.restriction_none = false;
      }
    },

    async checkExistCampaign(id) {
      if (this.form.advertiser?.id != id) {
        this.dataCampaignsByAdvertiser = [];
        try {
          this.onLoading(true);
          const { data, status } = await this.searchCampaign('page=1', 'perPage=100', `advertiserId=${id}`);
          if (status === 200 && data.data.length > 0) {
            this.dataCampaignsByAdvertiser = data.data;
            this.showModal = true;
          }
        } catch (error) {
          if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
          else this.errorNotify(error);
        } finally {
          this.onLoading(false);
        }
      }
    },

    deleteSpecificObjectInModel(id) {
      var indexComission = this.form.comissions.findIndex((ele) => {
        return ele.id === id;
      });

      if (indexComission !== -1) this.form.comissions.splice(indexComission, 1);
    },

    checkModeloNegociacao(modelo) {
      let comissions = this.form.comissions.filter((comission) => comission.type === modelo);
      if (modelo) return comissions;
    },

    checkExistCPC(modelo) {
      if (this.form.comissions.some((comission) => comission.type == modelo)) {
        return false;
      }
      return true;
    },

    addModeloNegociacao(modelo) {
      if (modelo == 'cpc') {
        if (!this.checkExistCPC(modelo)) return false;
      }

      this.indexComissionsArray++;

      switch (modelo) {
        case 'cpa':
          this.form.comissions.push({
            id: this.indexComissionsArray,
            type: 'cpa',
            category: null,
            format: null,
            currency: null,
            value: null
          });
          break;

        case 'cpl':
          this.form.comissions.push({
            id: this.indexComissionsArray,
            type: 'cpl',
            category: null,
            format: 'value',
            currency: null,
            value: null
          });
          break;

        case 'cpc':
          this.form.comissions.push({
            id: this.indexComissionsArray,
            type: 'cpc',
            category: null,
            format: 'value',
            currency: null,
            value: null
          });
          break;

        default:
          break;
      }
    },

    onClose() {
      // this.ActionSetDialogCampaign(false);
      this.$router.push({ name: 'Campaigns' });
    },

    async uploadLogoCampaign(image) {
      try {
        this.onLoading(true);

        let form = new FormData();
        form.append('image', image);
        form.append('bucket', 's3AdvertiserLogos');

        const { data, status } = await this.$http.post('/v2/upload/campaign-logo', form, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (status === 200) return data.image_upload.image_url;
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    advanceVerify() {
      if (this.form.comissions.length == 0)
        this.errorNotify(`${this.$t('select') + ' ' + this.$t('a') + ' ' + this.$t('negotiation_model')}`);
      else if (
        this.step == 'step2' &&
        !this.form.restriction_site_under &&
        !this.form.restriction_word_purchase &&
        !this.form.restriction_retargeting &&
        !this.form.restriction_email_marketing &&
        !this.form.restriction_none
      )
        this.errorNotify(this.$t('select_at_least_one_restriction'));
      else if (
        this.step == 'step2' &&
        !this.form.last_click &&
        !this.form.assisted &&
        !this.form.direct &&
        !this.form.organic
      )
        this.errorNotify(this.$t('select_at_least_one_attribution'));
      else this.$refs.formCampaign.next();
    },

    async onSave() {
      if (this.step == 'step3' && this.form.pi != null && this.form.pixel_contacts[0].phone != null) {
        if (!this.form.integration_type) {
          this.errorNotify(this.$t('please_select_integration_type'));
          return;
        }

        var logo_url = null;
        if (this.logo) {
          logo_url = await this.uploadLogoCampaign(this.logo);
        }
        let formData = this.form;
        let commercialManagerId = formData.comercial_manager.user_id;
        let commercialManagerName = formData.comercial_manager.name;
        // let budget_currency = formData.budget_currency.value;

        let integrationType = this.form.integration_type;
        if (integrationType === 'Outro') {
          integrationType = this.otherIntegrationType;
        }

        let data = {
          ...formData,
          url: `${this.form.url.protocol}${this.form.url.link}`,
          activation_date: this.form.activation_date.replace(/-/g, '/'),
          expiration_date: this.form.expiration_date ? this.form.expiration_date.replace(/-/g, '/') : '',
          logo_url: logo_url,
          advertiser_id: this.form.advertiser.id,
          agency_id: null,
          category_id: this.form.category_id.id,
          comercial_manager_id: commercialManagerId,
          comercial_manager_name: commercialManagerName,
          // budget_currency: budget_currency,
          pixel_contacts: JSON.stringify(formData.pixel_contacts),
          business_contact: JSON.stringify(formData.business_contact),
          comissions: JSON.stringify(formData.comissions),
          //Campos informacionais
          integration_type: integrationType,
          mastertag: formData.mastertag,
          gtm_release: formData.gtm_release,
          parameterized_url: formData.parameterized_url,
          test_method_real_data_registration: formData.test_method_real_data_registration,
          test_method_no_invoice_purchase: formData.test_method_no_invoice_purchase,
          test_method_other_issues: formData.test_method_other_issues,
          proof_method: formData.proof_method
        };

        if (this.form.agency_id !== null && this.form.agency_id.id) {
          data.agency_id = this.form.agency_id.id;
        }

        delete data.advertiser;
        delete data.comercial_manager;

        this.createCampaign(data);
      }
    },

    async createCampaign(dataCreateCampaign) {
      this.onLoading(true);
      try {
        const { status } = await this.createCampaignService(dataCreateCampaign);

        if (status === 200 || status === 201) {
          await this.$router.push('/campaigns');
          this.successNotify(this.$t('campaign_created_successfully'));
        }
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async updateCampaign(id) {
      this.onLoading(true);
      try {
        const { status } = await this.$http.put('users/edit/' + id, this.parseQs(this.form));
        if (status === 200 || status === 201) {
          this.getCampaigns();
          this.ActionSetDialogCampaign(false);
        }
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>

<style>
.file-upload .q-field__control,
.file-upload {
  min-height: 128px !important;
}
</style>
